// extracted by mini-css-extract-plugin
export default {"info":"infoButton_info__c8BnV","tooltip":"infoButton_tooltip__bZMWy","list":"infoButton_list__jDPHP"};